import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ProductList.css'; // Import your CSS file

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState(''); // New state for search term

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/products`);
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();
  }, []);

  const handleUpdateStock = async (productId, colorIndex, newStock) => {
    try {
      await axios.patch(`${process.env.REACT_APP_BASE_URL}/products/${productId}/colors/${colorIndex}`, { stock: newStock });
      const updatedProducts = products.map(product => {
        if (product._id === productId) {
          const updatedColors = product.colors.map((color, index) => {
            if (index === colorIndex) {
              return { ...color, stock: newStock };
            }
            return color;
          });
          return { ...product, colors: updatedColors };
        }
        return product;
      });
      setProducts(updatedProducts);
    } catch (error) {
      console.error('Error updating stock:', error);
      alert('Error updating stock');
    }
  };

  const handleDelete = async (productId) => {
    try {
      await axios.delete(`${process.env.REACT_APP_BASE_URL}/products/${productId}`);
      setProducts(products.filter((product) => product._id !== productId));
      alert('Product deleted successfully');
    } catch (error) {
      console.error('Error deleting product:', error);
      alert('Error deleting product');
    }
  };

  const handleStockChange = (productId, colorIndex, newStock) => {
    const updatedProducts = products.map(product => {
      if (product._id === productId) {
        const updatedColors = product.colors.map((color, index) => {
          if (index === colorIndex) {
            return { ...color, stock: newStock };
          }
          return color;
        });
        return { ...product, colors: updatedColors };
      }
      return product;
    });
    setProducts(updatedProducts);
    handleUpdateStock(productId, colorIndex, newStock);
  };

  const filteredProducts = products.filter(product => 
    product.productId.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className='productList'>
      <h2>Product List</h2>
      <div className="search-container">
        <input
          type="text"
          placeholder="Search by Product ID"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <table className='plTable'>
        <thead>
          <tr>
            <th>Name</th>
            <th>Id</th>
            <th>Category</th>
            <th>Sub Category</th>
            <th>Short Description</th>
            <th>Long Description</th>
            <th>Listing Price</th>
            <th>Selling Price</th>
            <th>Colors</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts.map((product) => (
            <tr key={product._id}>
              <td>{product.name}</td>
              <td>{product.productId}</td>
              <td>{product.category}</td>
              <td>{product.subCategory}</td>
              <td>{product.shortDescription}</td>
              <td>{product.longDescription}</td>
              <td>{product.listingPrice}</td>
              <td>{product.sellingPrice}</td>
              <td>
                <ul>
                  {product.colors.map((color, index) => (
                    <li key={index}>
                      <strong>{color.color}</strong> - Stock: {color.stock}, Priority: {color.priority}
                      <input
                        type="number"
                        value={color.stock}
                        onChange={(e) => handleStockChange(product._id, index, parseInt(e.target.value, 10))}
                        placeholder="New Stock"
                      />
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                <ul className="small-images">
                  {product.colors.map((color, index) => (
                    <li key={index}>
                      <strong>{color.color}</strong>
                      {color.images.length > 0 && (
                        <img src={`${process.env.REACT_APP_BASE_URL}/${color.images[0]}`} alt={`Color ${index}`} />
                      )}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                <button onClick={() => handleDelete(product._id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductList;
